import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastService } from 'src/app/services/toast/toast.service';
import { ApiService } from 'src/app/_services/api.service';
import { AuthService } from 'src/app/_services/auth.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  forgotpasswordForm: UntypedFormGroup = new UntypedFormGroup({});
  loadingPage = false;
  constructor(
    private toastMessagesService: ToastService,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.initLoginForm();
  }

  private initLoginForm(): void {
    this.forgotpasswordForm = new UntypedFormGroup(
      {
        email: new UntypedFormControl('', [Validators.required, Validators.email]),
        languageId: new UntypedFormControl(0, [Validators.required]),
      }
    );
  }

  onForgotPasswordFormSubmit(): void {
    if (this.forgotpasswordForm.invalid) {
      return;
    }
    this.loadingPage = true;
    let data = this.forgotpasswordForm.value;
    let languageId = localStorage.getItem('languageId');
    if (languageId != null) {
      data.languageId = parseInt(languageId);
    }
    this.apiService.forgotpassword(data).subscribe((response) => {
      if (response) {
        this.toastMessagesService.nextToastMessage({
          severity: 'success',
          summary: 'Success',
          detail: response.message
        });
        this.loadingPage = false;
      }
    });
  }


  get forgotpasswordFormControls() {
    return this.forgotpasswordForm.controls;
  }
}
